import React, { useEffect, useState } from "react";
import { Link, Route, Switch, useRouteMatch } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import ProductList from "../../Products/ProductList/ProductList";
import AddReview from "../../Review/AddReview/AddReview";
import AddProducts from "../AddProduct/AddProducts";
import MankeAdmin from "../MakeAdimn/MankeAdmin";
import ManageAllOrder from "../ManageAllOrder/ManageAllOrder";
import MyOrders from "../MyOrder/MyOrders";
import Payment from "../Payment/Payment";
import "./MyDashboard.css";
const MyDeshbord = () => {
  let { path, url } = useRouteMatch();
  const { user, logOut } = useAuth();
  const [isAdmin, setAdmin] = useState(false);

  useEffect(() => {
    fetch(`https://salty-stream-34659.herokuapp.com/chackadmin/${user.email}`)
      .then((res) => res.json())
      .then((data) => {
        if (data[0]?.role === "admin") {
          setAdmin(true);
        } else {
          setAdmin(false);
        }
      });
  }, [user.email]);
  console.log(isAdmin);

  return (
    <div className="myDashboard container-fluid">
      <div className="row">
        <div
          className="col-lg-2 col-md-2 col-sm-1 col-1  pt-4 "
          id="dashboaard"
        >
          <h3 className="text-center">
            {" "}
            <i class="fas fa-home    "></i> Dashboard
          </h3>
          <ul>
            {isAdmin && (
              <div>
                <li>
                  <Link exact to={`${url}`}>
                    <i class="fas fa-address-card    "></i>
                    <span>Add Product</span>
                  </Link>
                </li>
                <li>
                  <Link exact to={`${url}/productlist`}>
                    <i class="fas fa-edit    "></i>
                    <span>Manage Products</span>
                  </Link>
                </li>
                <li>
                  <Link to={`${url}/manageorder`}>
                    <i class="fab fa-expeditedssl    "></i>
                    <span> Manage All orders</span>
                  </Link>
                </li>
                <li>
                  <Link to={`${url}/makeadmin`}>
                    <i class="fas fa-users    "></i>
                    <span> Make Admin</span>
                  </Link>
                </li>
              </div>
            )}
            {!isAdmin && (
              <div>
                <li>
                  <Link to={`${url}/myorders`}>
                    <i class="fas fa-shopping-bag    "></i>
                    <span> My Orders</span>
                  </Link>
                </li>
                <li>
                  <Link to={`${url}/payment`}>
                    <i class="fas fa-money-bill    "></i>
                    <span> Payment</span>
                  </Link>
                </li>
                <li>
                  <Link to={`${url}/review`}>
                    <i class="fas fa-street-view    "></i>
                    <span> Review</span>
                  </Link>
                </li>
              </div>
            )}

            <li className="d-flex ">
              {user?.email && (
                <li
                  onClick={logOut}
                  style={{ alignItems: "center", justifyContent: "center" }}
                >
                  <i
                    class="fas fa-sign-out-alt   "
                    style={{
                      display: "dlex",
                      alignItems: "center",
                      justifyContent: "center",
                      paddingTop: "12px",
                    }}
                  ></i>
                  <span>Logout</span>
                </li>
              )}
            </li>
          </ul>
        </div>
        <div className="col-lg-10 col-sm-12 col-8 ">
          <div className="text-center">
            <Switch>
              <Route exact path={path}>
                <AddProducts />
              </Route>
              <Route path={`${path}/myorders`}>
                <MyOrders />
              </Route>
              <Route path={`${path}/productlist`}>
                <ProductList />
              </Route>
              <Route path={`${path}/manageorder`}>
                <ManageAllOrder />
              </Route>
              <Route path={`${path}/review`}>
                <AddReview />
              </Route>
              <Route path={`${path}/payment`}>
                <Payment />
              </Route>
              <Route path={`${path}/makeadmin`}>
                <MankeAdmin />
              </Route>
            </Switch>
            {/* <AddProducts />
            <MyOrders />
            <ManageAllOrder /> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyDeshbord;
